import React, { useState, useEffect } from 'react';
import { useAPI } from '../../ApiCalls/useAPI';
import { Avatar, Card, Grid, Table } from 'tabler-react';
import RemoveLastDirectoryPartOf from '../goBackButton';
import MoonLoader from 'react-spinners/MoonLoader';
import './Profile.scss';

export default function Profile() {
    const [data, setData] = useState([]);
    console.log(data)
    const { getProfile } = useAPI();
    useEffect(() => {
        getProfile()
            .then((response) => setData(response))
            .catch((error) => console.error(error));
    }, []);

    const override = `
            display: block;
            margin: 10% auto;
            border-color: red;
        `;
    if (data.length === 0) {
        return (
            <div>
                <h1 className="mt-4" style={{ textAlign: 'center' }}>
                    Waiting for data ...
                </h1>
                <MoonLoader
                    color={'green'}
                    isLoading={true}
                    css={override}
                    size={60}
                />
            </div>
        );
    }
    return (
        <div className="container">
            <div className="m-2" style={{ fontSize: '20px', display: 'flex' }}>
                <div className="mr-4">
                    <a
                        href={RemoveLastDirectoryPartOf(window.location.href)}
                        style={{ textDecoration: 'none' }}
                    >
                        <i className="fe fe-arrow-left" />
                    </a>
                </div>
                <div>Profile</div>
            </div>
            <Card
                body={
                    <div>
                        <div id="mobprofile">
                            <div
                                style={{
                                    justifyContent: 'center',
                                    display: 'flex'
                                }}
                            >
                                <div>
                                    <div style={{ textAlign: 'center' }}>
                                        <Avatar.List>
                                            <Avatar
                                                className="m-4"
                                                style={{
                                                    height: '170px',
                                                    width: '170px'
                                                }}
                                                imageURL={data.picture}
                                            />
                                        </Avatar.List>
                                    </div>
                                    <div
                                        className="m-4"
                                        style={{ textAlign: 'center' }}
                                    >
                                        <h1>
                                            {data.firstname} {data.lastname}{' '}
                                        </h1>
                                        <div style={{ fontSize: '20px' }}>
                                            {data.hallticketno}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <Grid.Row>
                                    <Grid.Col
                                        sm={12}
                                        md={10}
                                        offsetMd={1}
                                        lg={8}
                                        offsetLg={2}
                                        xl={4}
                                        offsetXl={4}
                                    >
                                        <Table>
                                            <Table.Body>
                                                <Table.Row m="auto">
                                                    <Table.Col alignContent="left">
                                                        Year
                                                    </Table.Col>
                                                    <Table.Col alignContent="right">
                                                        {data.currentyear}
                                                    </Table.Col>
                                                </Table.Row>
                                                <Table.Row>
                                                    <Table.Col alignContent="left">
                                                        Branch
                                                    </Table.Col>
                                                    <Table.Col alignContent="right">
                                                        {data.dept}
                                                    </Table.Col>
                                                </Table.Row>
                                                <Table.Row>
                                                    <Table.Col alignContent="left">
                                                        Section
                                                    </Table.Col>
                                                    <Table.Col alignContent="right">
                                                        {data.section}
                                                    </Table.Col>
                                                </Table.Row>
                                                <Table.Row>
                                                    <Table.Col alignContent="left">
                                                        Sanjaya ID
                                                    </Table.Col>
                                                    <Table.Col alignContent="right">
                                                        {data.rollno}
                                                    </Table.Col>
                                                </Table.Row>
                                            </Table.Body>
                                        </Table>
                                    </Grid.Col>
                                </Grid.Row>
                            </div>
                        </div>
                        <div id="profile">
                            <div className="profilecontainer">
                                <div className="leftprofile">
                                    <div
                                        style={{
                                            justifyContent: 'center',
                                            display: 'flex'
                                        }}
                                    >
                                        <div>
                                            <div>
                                                <div className="profileimgcontainer">
                                                    <img
                                                        className="profileimg"
                                                        src={data.picture}
                                                        alt="profile"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="rightprofile">
                                    <div
                                        className="m-6"
                                        style={{ textAlign: 'center' }}
                                    >
                                        <div className="profilename">
                                            {data.firstname} {data.lastname}
                                        </div>
                                        <div style={{ fontSize: '20px' }}>
                                            {data.hallticketno}
                                        </div>
                                    </div>
                                    <div className="tablecontainer">
                                        <Grid.Row>
                                            <Grid.Col xl={12}>
                                                <Table>
                                                    <Table.Body>
                                                        <Table.Row m="auto">
                                                            <Table.Col alignContent="left">
                                                                Year
                                                            </Table.Col>
                                                            <Table.Col alignContent="right">
                                                                {
                                                                    data.currentyear
                                                                }
                                                            </Table.Col>
                                                        </Table.Row>
                                                        <Table.Row>
                                                            <Table.Col alignContent="left">
                                                                Branch
                                                            </Table.Col>
                                                            <Table.Col alignContent="right">
                                                                {data.dept}
                                                            </Table.Col>
                                                        </Table.Row>
                                                        <Table.Row>
                                                            <Table.Col alignContent="left">
                                                                Section
                                                            </Table.Col>
                                                            <Table.Col alignContent="right">
                                                                {data.section}
                                                            </Table.Col>
                                                        </Table.Row>
                                                        <Table.Row>
                                                            <Table.Col alignContent="left">
                                                                Sanjaya ID
                                                            </Table.Col>
                                                            <Table.Col alignContent="right">
                                                                {data.rollno}
                                                            </Table.Col>
                                                        </Table.Row>
                                                    </Table.Body>
                                                </Table>
                                            </Grid.Col>
                                        </Grid.Row>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            />
        </div>
    );
}
